import type { PickStatus } from '@modules/core/enums';
import type { ITableState } from '@modules/tables/types';
import type { ILoginResponseUser } from '@modules/user/types';

import type { INoneNegativeCarryoverPayloadData } from '../submodules/none-negative-carryover/types';

export interface IAffiliatesTableDataResponseRecord {
  id: number;
  email?: string;
  name?: string;
  site_url?: string;
  username?: string;
  last_seen_at?: string;
  trackers_count?: number;
  telegram?: string;
  role_name?: string;
  manager?: string;
  status?: string;
  subscription?: string;
  mfa_enabled?: boolean;
}

// Change Manager Dialog
export const ManagerField = 'manager' as const;

export interface IChangeManagerFormPayload {
  [ManagerField]: number;
}

export interface IChangeDepartmentForm {
  department_id?: number;
}

export interface IChangeManagerPayload {
  manager_id: IChangeManagerFormPayload[typeof ManagerField];
  affiliate_ids: number[];
  segment_id: ITableState['filter_set_id'];
  page: ITableState['page'];
}

export type IChangeDepartmentPayload = Omit<IChangeManagerPayload, 'manager_id'> & IChangeDepartmentForm;

export interface IChangeNncoPayload extends
  Pick<INoneNegativeCarryoverPayloadData, 'enable_nnco' | 'date'>,
  Pick<IChangeManagerPayload, 'affiliate_ids' | 'segment_id' | 'page'> {}

// Get Manager for Affiliates
export interface IManagerItem {
  id: number;
  name: string;
}

export type IManagersList = IManagerItem[];

export interface IGetManagersResponse {
  list: IManagersList;
}

export interface IGetDepartmentsResponse {
  list: IDepartmentItem[];
}

export interface IDepartmentItem {
  id: number;
  name: string;
  aasm_state: PickStatus<'DEFAULT' | 'STANDARD'>;
}

export interface ISupervisionResponse {
  current_user: ILoginResponseUser;
}
